export default __webpack_public_path__ + "static/media/For the Family.8cba526d.png";